import axios from "axios";
import { LocalStorage } from "utils/LocalStorage";
import { handleSessionExpired } from "reduxStore/auth/thunks";
import { attachApiExceptionTracking } from "utils/amplitudeAnalytics";

declare module "axios" {
  export interface AxiosRequestConfig {
    preserveSessionOnUnauthorized?: boolean;
  }
}

/**
 * @description Axios instance used for API requests
 */
export const API = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
});

attachApiExceptionTracking(API);

API.interceptors.request.use((config) => {
  const appToken = LocalStorage.getToken();
  if (appToken && config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${appToken}`;
  }
  if (config.headers) {
    config.headers["Accept-Language"] = "en-US";
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status !== 401 ||
      error.config?.preserveSessionOnUnauthorized
    ) {
      return Promise.reject(error);
    }
    handleSessionExpired().then();
    return Promise.reject(error);
  },
);
